






import { Component, Vue, Prop } from 'vue-property-decorator';
import Form from '@/classes/Form';

@Component
export default class InNeedOfActionCard extends Vue {
    @Prop() public forms!: Form[];
    @Prop() public goto!: string;

    public sendTo(destination: string): void {
        this.$router.push(destination);
    }
}
